"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsMissingPluginError = void 0;

var _BasePluginError2 = require("./BasePluginError");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OptionsMissingPluginError =
/*#__PURE__*/
function (_BasePluginError) {
  _inherits(OptionsMissingPluginError, _BasePluginError);

  /* istanbul ignore next */
  function OptionsMissingPluginError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : OptionsMissingPluginError._MESSAGE_;

    _classCallCheck(this, OptionsMissingPluginError);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptionsMissingPluginError).call(this, message));
  }

  return OptionsMissingPluginError;
}(_BasePluginError2.BasePluginError);

exports.OptionsMissingPluginError = OptionsMissingPluginError;

_defineProperty(OptionsMissingPluginError, "_MESSAGE_", 'missing plugin options');
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvRXhjZXB0aW9ucy9PcHRpb25zTWlzc2luZ1BsdWdpbkVycm9yLnRzIl0sIm5hbWVzIjpbIk9wdGlvbnNNaXNzaW5nUGx1Z2luRXJyb3IiLCJtZXNzYWdlIiwiX01FU1NBR0VfIiwiQmFzZVBsdWdpbkVycm9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQUVhQSx5Qjs7Ozs7QUFHWDtBQUNBLHVDQUFtRTtBQUFBLFFBQXZEQyxPQUF1RCx1RUFBckNELHlCQUF5QixDQUFDRSxTQUFXOztBQUFBOztBQUFBLGtHQUMzREQsT0FEMkQ7QUFFbEU7OztFQU40Q0UsaUM7Ozs7Z0JBQWxDSCx5QixlQUNtQyx3QiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEJhc2VQbHVnaW5FcnJvciB9IGZyb20gJy4vQmFzZVBsdWdpbkVycm9yJ1xuXG5leHBvcnQgY2xhc3MgT3B0aW9uc01pc3NpbmdQbHVnaW5FcnJvciBleHRlbmRzIEJhc2VQbHVnaW5FcnJvciB7XG4gIHByb3RlY3RlZCBzdGF0aWMgcmVhZG9ubHkgX01FU1NBR0VfOiBzdHJpbmcgPSAnbWlzc2luZyBwbHVnaW4gb3B0aW9ucydcblxuICAvKiBpc3RhbmJ1bCBpZ25vcmUgbmV4dCAqL1xuICBjb25zdHJ1Y3RvcihtZXNzYWdlOiBzdHJpbmcgPSBPcHRpb25zTWlzc2luZ1BsdWdpbkVycm9yLl9NRVNTQUdFXykge1xuICAgIHN1cGVyKG1lc3NhZ2UpXG4gIH1cbn1cbiJdfQ==